import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Alert
} from '@mui/material';
import axios from 'axios';
import { useToast } from '../../contexts/ToastContext';

/**
 * Dialog for creating an intimation from AMP schedule.
 * CA can then create the work order from the Intimations tab.
 */
const CreateIntimationFromAMPScheduleDialog = ({
  open,
  onClose,
  onSuccess,
  ampSchedule
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { showToast } = useToast();

  const handleCreate = async () => {
    if (!ampSchedule) return;

    setLoading(true);
    setError('');
    try {
      await axios.post(`/api/amp-schedules/${ampSchedule._id}/create-intimation`);
      showToast('Intimation created successfully', 'success');
      onSuccess();
      onClose();
    } catch (err) {
      const message = err.response?.data?.message || 'Failed to create intimation';
      setError(message);
      showToast(message, 'error');
    } finally {
      setLoading(false);
    }
  };

  if (!ampSchedule) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Create Intimation from AMP Schedule</DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
            {error}
          </Alert>
        )}
        <Box sx={{ mt: 2 }}>
          <Typography variant="body1" gutterBottom>
            <strong>AMP Schedule:</strong> {ampSchedule.title}
            {' '}
            <Box component="span" sx={{ color: 'text.secondary', fontSize: '0.875rem' }}>
              ({ampSchedule.ampScheduleNumber || (ampSchedule._id ? `AMP-${ampSchedule._id.toString().slice(-8).toLowerCase()}` : '')})
            </Box>
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            <strong>Aircraft:</strong> {ampSchedule.aircraftId?.registration || 'Unknown'}
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            <strong>Maintenance Type:</strong> {ampSchedule.maintenanceType === 'LINE_INSPECTION' ? 'Line Inspection' : 'Base Inspection'}
          </Typography>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            <strong>Number of Checks:</strong> {ampSchedule.ampChecks?.length || 0}
          </Typography>
          <Alert severity="info" sx={{ mt: 2 }}>
            An intimation will be created and linked to this AMP schedule. Create the work order from the Intimations tab and acknowledge with the WO number.
          </Alert>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={handleCreate}
          variant="contained"
          disabled={loading}
        >
          {loading ? 'Creating...' : 'Create Intimation'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateIntimationFromAMPScheduleDialog;
